export default __webpack_public_path__ + "static/media/138410__cameronmusic__item-collect-2.32a20067.mp3";